import React, { useEffect, useState } from "react";
import classnames from "classnames";

type Props = {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  activeCategory: string | string[] | undefined;
  category?: string;
  children: React.ReactNode;
  isAllResults?: boolean;
};

const FilterPill: React.FC<Props> = ({
  onClick,
  children,
  category,
  isAllResults = false,
  activeCategory,
}) => {
  const [isPillActive, setIsPillActive] = useState(false);

  useEffect(() => {
    setIsPillActive(activeCategory === category);
  }, [activeCategory, category]);

  return isAllResults ? (
    <button
      className={classnames(
        "flex-shrink-0 rounded-full px-sm mr-md mb-md text-xs font-bold",
        {
          "bg-default text-white": !activeCategory,
          "border border-none text-green": activeCategory,
        },
      )}
      data-value={null}
      onClick={onClick}
      data-testid="filter-all"
    >
      {children}
    </button>
  ) : (
    <button
      className={classnames(
        "flex-shrink-0 rounded-full px-sm mr-md mb-md text-xs font-bold",
        {
          "bg-default text-white": isPillActive,
          "border border-none text-green": !isPillActive,
        },
      )}
      data-value={category}
      onClick={onClick}
      data-testid={`filter-${category}`}
    >
      {children}
    </button>
  );
};

export default FilterPill;
